var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { Translate, t } from "../../../I18N";
import { isString } from 'lodash';
import { Button, Modal } from "../UI";
















const ConfirmationModal = ({
  header,
  body,
  onAcceptClick,
  onCancelClick,
  acceptButton,
  cancelButton,
  warningText,
  confirmWord,
  usePassword,
  size = 'md',
  dangerStyle = false
}) => {
  const [inputValue, setInputValue] = useState('');
  const [confirmed, setConfirmed] = useState(!(confirmWord || usePassword));

  const renderChild = (child) =>
  isString(child) ? /*#__PURE__*/_jsx(Translate, {}, void 0, child) : child;

  const wordForConfirmation = t('System', confirmWord, null, false);

  return (/*#__PURE__*/
    _jsx(Modal, { size: size }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, { className: "border-b-0" }, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0, renderChild(header)), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: onCancelClick })
    ),
    warningText && /*#__PURE__*/
    _jsx("div", {
      className: "p-4 text-sm border-t border-b border-error-300 text-error-800 bg-error-50 top--3 dark:bg-gray-800 dark:text-error-400",
      role: "alert" }, void 0,

    renderChild(warningText)
    ), /*#__PURE__*/

    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-gray-500 whitespace-nowrap dark:text-gray-400" }, void 0,
    renderChild(body)
    ),
    confirmWord && /*#__PURE__*/
    _jsx("div", { className: "py-4" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "block mb-2 font-medium text-gray-900 text-md dark:text-white" }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "confirm-input" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Please type in"), "\xA0"
    ),
    wordForConfirmation, ":"
    ), /*#__PURE__*/
    _jsx("input", {
      id: "confirm-input",
      className: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
      type: "text",
      onChange: (e) => setConfirmed(e.currentTarget.value === wordForConfirmation),
      "data-testid": "confirm-input" }
    )
    ),


    usePassword && /*#__PURE__*/
    _jsx("div", { className: "py-4" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "block mb-2 font-medium text-gray-900 text-md dark:text-white" }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "confirm-password" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Enter your current password to confirm"), "\xA0"
    )
    ), /*#__PURE__*/
    _jsx("input", {
      id: "confirm-password",
      className: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
      type: "password",
      autoComplete: "off",
      onChange: (e) => {
        setInputValue(e.currentTarget.value);
        setConfirmed(e.currentTarget.value.length > 0);
      } }
    )
    )

    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: onCancelClick,
      className: "grow",
      "data-testid": "cancel-button" }, void 0,

    renderChild(cancelButton || 'Cancel')
    ), /*#__PURE__*/
    _jsx(Button, {
      onClick: onAcceptClick ? () => onAcceptClick(inputValue || '') : undefined,
      disabled: !confirmed,
      color: !warningText && !dangerStyle ? 'primary' : 'error',
      className: "grow",
      "data-testid": "accept-button" }, void 0,

    renderChild(acceptButton || 'Accept')
    )
    )
    ));

};

export { ConfirmationModal };